import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import './index.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Route for Login page */}
        <Route path="/login" element={<Login />} />
        {/* Route for Dashboard page */}
        <Route path="/dashboard/*" element={<Dashboard />} />
        {/* Redirect to /dashboard/sections when the app starts */}
        <Route path="/" element={<Navigate to="/dashboard/sections" replace />} />
      </Routes>
    </Router>
  );
}

export default App;